import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { FlightSession } from '.';

const FlightReviewsContext = React.createContext({});

export const useFlightReviews = () => {
  return React.useContext(FlightReviewsContext);
};

export default function FlightReviewsProvider(props) {
  const inbound = FlightSession.getInbound() || null;
  const outbound = FlightSession.getOutbound();
  const {
    firstName,
    lastName,
    contactEmail,
    contactMobile,
    passengerDetails,
  } = FlightSession.getPassengerDetails();

  const contactPerson = {
    contactName: `${firstName} ${lastName}`,
    contactMobile,
    contactEmail,
  };

  if (isEmpty(outbound) || isEmpty(passengerDetails)) return null;

  return (
    <FlightReviewsContext.Provider
      value={{ inbound, outbound, passengerDetails, contactPerson }}
    >
      {props.children}
    </FlightReviewsContext.Provider>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/FlightReviewsProvider.js